import { c as _c } from "react/compiler-runtime";
import { useFormatter, useTranslations } from 'next-intl';
import { AnimatedProgressCircle } from '@/components/ui/animated-progress-circle';
import type { ResolutionIntegrity } from './resolution-integrity-types';
const RING_DIAMETER = 128;
const RING_STROKE = 8;
export function DemocracyScoreRing(t0) {
  const $ = _c(15);
  const {
    score
  } = t0;
  const t = useTranslations("market.resolutionIntegrity");
  const intl = useFormatter();
  const value = score.value;
  let t1;
  if ($[0] !== t) {
    t1 = t("scoreLabel");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = value ?? 0;
  let t3;
  if ($[2] !== intl || $[3] !== t || $[4] !== value) {
    t3 = value === null ? <span className="px-3 text-center text-body font-medium text-foreground-tertiary">{t("unavailable")}</span> : <span className="flex flex-col items-center"><span data-testid="democracy-score-value" className="text-display font-semibold tabular-nums text-foreground-primary">{intl.number(value)}</span><span className="text-caption text-foreground-secondary">{t("scoreOutOf", {
          max: intl.number(100)
        })}</span></span>;
    $[2] = intl;
    $[3] = t;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <AnimatedProgressCircle label={t1} progress={t2} diameter={RING_DIAMETER} strokeWidth={RING_STROKE} trackOpacity={0.15} strokeClassName="stroke-feedback-info-accent" trackClassName="stroke-foreground-tertiary">{t3}</AnimatedProgressCircle>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== score.unavailableReason) {
    t5 = score.unavailableReason === null ? null : <p data-testid="democracy-score-unavailable" className="text-center text-caption text-foreground-secondary"><UnavailableCopy reason={score.unavailableReason} /></p>;
    $[10] = score.unavailableReason;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex shrink-0 flex-col items-center gap-2 sm:w-40">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function UnavailableCopy(t0) {
  const $ = _c(6);
  const {
    reason
  } = t0;
  const t = useTranslations("market.resolutionIntegrity");
  switch (reason) {
    case "holders_unavailable":
      {
        let t1;
        if ($[0] !== t) {
          t1 = t("unavailableHolders");
          $[0] = t;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "insufficient_holders":
      {
        let t1;
        if ($[2] !== t) {
          t1 = t("unavailableInsufficient");
          $[2] = t;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "uncontested":
      {
        let t1;
        if ($[4] !== t) {
          t1 = t("unavailable");
          $[4] = t;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
  }
}